import { InjectionToken } from '@angular/core';
import { Environment } from './environment';

export const EnvironmentToken = new InjectionToken<Environment>('Per App Environment Configuration');
